import Sidebars from "./SideBar";
import SassPmsList from "../../pages/PMS/LOGIN";
import NotificationMessage from "./NotificationMessage";
import useNotificationSignalR from "../../hooks/useNotificationSignalR";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { putVesselDetail } from "../../features/commonSlice";
import { fetchVesselApi } from "../../features/vesselSlice";
import { BsBellFill } from "react-icons/bs";
import {
  fetchNotificationFeed,
  fetchUnreadCount,
  pushNotification,
  resetNotifications,
} from "../../features/notificationSlice";
import { COLOR } from "../common/uiTokens";

// Matches the old .form-select.top-select look — react-select doesn't pick it up from index.scss.
const vesselSelectStyles = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  styles: {
    menuPortal: (base) => ({ ...base, zIndex: 1056 }),
    control: (base) => ({
      ...base,
      minHeight: 38,
      height: 38,
      background: "#f6f8fb",
      border: "none",
      borderRadius: 10,
      boxShadow: "none",
    }),
    valueContainer: (base) => ({ ...base, height: 38, padding: "0 8px" }),
    input: (base) => ({ ...base, margin: 0, padding: 0 }),
    indicatorsContainer: (base) => ({ ...base, height: 38 }),
    singleValue: (base) => ({ ...base, color: "rgba(78, 96, 128, 0.85)", fontWeight: 600 }),
    placeholder: (base) => ({ ...base, color: "rgba(78, 96, 128, 0.5)", fontWeight: 600 }),
  },
};

const NavMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const path = useMemo(() => {
    const storedPath = localStorage.getItem("loginPath");
    return storedPath ? JSON.parse(storedPath) : null;
  }, []);
  const pathName = path?.pathName;

  const [showNotification, setShowNotification] = useState(false);
  const [profileToggle, setProfile] = useState(false);

  const { unreadCount = 0, gate } = useSelector(
    (state) => state.root.notification,
  );

  const { first_name, Designation } = useSelector(
    (state) => state.root.login.loginDemo,
  );

  const loginDetails = useSelector((state) => state.root.login.loginDemo);

  const vessel_id = useSelector(
    (state) => state.root.common.vessel_detailByID?.id,
  );

  const vessel_list = useSelector((state) => state.root.vessel.list);

  const appVersionNumber = process.env.REACT_APP_VERSION;

  const vesselList =
    useSelector((state) => state.root.login.loginDemo?.vesselDetails) || [];

  const vesselSelectOptions = vesselList.map((x) => ({ value: x.id, label: x.vessel_name }));
  // String-compare: vesselList and vessel_id come from different sources whose id types don't always match.
  const selectedVesselOption =
    vesselSelectOptions.find((o) => String(o.value) === String(vessel_id)) || null;

  const notificationsEnabled = Boolean(
    loginDetails?.isLogin && !loginDetails?.is_admin,
  );

  // The feed is the source of truth; the socket only accelerates it. It is not
  // scoped to the selected vessel — see notificationSlice.
  const refreshNotifications = useCallback(() => {
    if (!notificationsEnabled) return;

    dispatch(fetchNotificationFeed());
    dispatch(fetchUnreadCount());
  }, [dispatch, notificationsEnabled]);

  // Clear the previous session's rows rather than showing them to whoever signs
  // in next. A vessel switch no longer needs one — the bell spans every vessel.
  useEffect(() => {
    dispatch(resetNotifications());
    refreshNotifications();
  }, [dispatch, refreshNotifications]);

  useEffect(() => {
    if (!loginDetails.isLogin) return;

    dispatch(fetchVesselApi())
      .unwrap()
      .then((res) => {
        let vesselList = res.filter((x) => x.vessel_name === "OFFICE");
        vessel_id === undefined && dispatch(putVesselDetail(vesselList[0]));
      });
  }, [dispatch, loginDetails.isLogin, vessel_id]);

  useEffect(() => {
    !loginDetails.isLogin && (pathName === "/login" || pathName === "/")
      ? navigate("/login")
      : !loginDetails.isLogin &&
          (pathName === "/saas-login" || pathName === "/")
        ? navigate("/saas-login")
        : !loginDetails.isLogin &&
          pathName === "/admin-login" &&
          navigate("/admin-login");

    !loginDetails.isLogin && path === null && navigate("/login");
  }, [loginDetails.isLogin, navigate, path, pathName]);

  useNotificationSignalR({
    enabled: notificationsEnabled,
    // The push carries the same shape as a feed row, so it needs no refetch.
    onNotification: (message) => {
      if (message) dispatch(pushNotification(message));
    },
    onReconnected: refreshNotifications,
  });

  const vesselChange = (arg) => {
    // Same id-type mismatch as selectedVesselOption above.
    const vesselDetail = vessel_list.filter((x) => String(x.id) === String(arg));
    if (!vesselDetail[0]) {
      toast.error("This vessel isn't available right now — please pick another one.");
      return;
    }
    dispatch(putVesselDetail(vesselDetail[0]));
  };

  const handleBellClick = () => {
    setShowNotification(!showNotification);
  };

  return (
    <div>
      <SassPmsList />
      {!loginDetails?.is_admin && (
        <Navbar className="appHeader" expand="lg" fixed="top">
          <Container fluid>
            <Navbar.Toggle aria-controls="headerNavbarNav" />
            <Navbar.Collapse id="headerNavbarNav">
              <Nav className="ms-auto d-flex align-items-center">
                {/* Feed is gated per tenant; hide the bell entirely when off. */}
                {gate !== "disabled" && (
                  <div className={"position-relative me-3"}>
                    <BsBellFill
                      style={{ color: "#8798B2", cursor: "pointer" }}
                      className={"notify align-content-center d-flex"}
                      onClick={handleBellClick}
                    />
                    {showNotification && !loginDetails?.is_admin && (
                      <div
                        className={"position-fixed bg-white rounded"}
                        style={{
                          marginTop: "-1px",
                          marginLeft: "-310px",
                          border: "1px solid #e2e8f0",
                          borderRadius: 12,
                          boxShadow: "0 8px 24px rgba(15, 31, 61, 0.12)",
                          width: "340px",
                        }}
                      >
                        <NotificationMessage
                          onNavigate={() => setShowNotification(false)}
                        />
                      </div>
                    )}
                    {unreadCount > 0 && (
                      <span className={"position-absolute notify-count"}>
                        {unreadCount}
                      </span>
                    )}
                  </div>
                )}

                <div className="me-2" style={{ minWidth: 160 }}>
                  <Select
                    options={vesselSelectOptions}
                    value={selectedVesselOption}
                    onChange={(option) => vesselChange(option ? option.value : "")}
                    placeholder="Choose Vessel"
                    isSearchable
                    {...vesselSelectStyles}
                  />
                </div>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}

      <div className="leftFixed12">
        <Sidebars setProfile={(e) => setProfile(e)} />
        <div
          style={{
            position: "fixed",
            width: profileToggle ? 45 : 180,
            bottom: 0,
            color: "#fff",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              padding: "10px 4px 6px",
              borderTop: "1px solid rgba(255,255,255,0.12)",
            }}
          >
            <div
              className="d-flex align-items-center"
              style={profileToggle ? { justifyContent: "center" } : undefined}
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: COLOR.grayBg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                {loginDetails?.repository &&
                loginDetails.repository.length > 0 ? (
                  <img
                    src={loginDetails.repository[0].fileurl}
                    alt={"profile"}
                    title={"user"}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  // #051134 matches .ps-sidebar-container's background in index.scss.
                  <i className="fa fa-fw fa-user" style={{ color: "#051134", fontSize: 13 }} />
                )}
              </div>
              {!profileToggle && (
                <div className="d-flex flex-column" style={{ marginLeft: 10, minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: 700,
                      color: "#fff",
                      lineHeight: 1.25,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={first_name}
                  >
                    {first_name}
                  </div>
                  <span
                    style={{
                      fontSize: 12,
                      color: "rgba(255,255,255,0.65)",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={Designation}
                  >
                    {Designation}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div
            style={{
              padding: "2px 4px 12px",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              fontSize: "12px",
            }}
          >
            {profileToggle
              ? appVersionNumber
              : `Version: ${appVersionNumber} ${new Date().getFullYear()}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavMenu;
